"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.w = exports.Y = exports.W = exports.S = exports.Q = exports.MS = exports.MIN = exports.M = exports.H = exports.DATE = exports.D = void 0;
// English locales
var MS = 'millisecond';
exports.MS = MS;
var S = 'second';
exports.S = S;
var MIN = 'minute';
exports.MIN = MIN;
var H = 'hour';
exports.H = H;
var D = 'day';
exports.D = D;
var w = 'week';
exports.w = w;
var W = 'isoWeek';
exports.W = W;
var M = 'month';
exports.M = M;
var Q = 'quarter';
exports.Q = Q;
var Y = 'year';
exports.Y = Y;
var DATE = 'date';
exports.DATE = DATE;